/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/travel-house.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Travel House',
  definitions: {
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.9741 5.79938C23.5716 5.31297 24.4285 5.31297 25.0259 5.79938L43.1929 20.5893C43.572 20.8979 43.792 21.3607 43.792 21.8495V23.4053C43.792 24.7719 42.2078 25.5282 41.1452 24.6689L37.8769 22.0259V40.5161C37.875 41.1359 37.628 41.7299 37.1897 42.1682C36.7514 42.6064 36.1574 42.8535 35.5376 42.8553L35.5357 42.8553H12.4642L12.4624 42.8553C11.8425 42.8535 11.2485 42.6065 10.8102 42.1682C10.3719 41.7299 10.1248 41.1359 10.123 40.516L10.123 40.5142V22.0259L6.85481 24.6689C5.79222 25.5282 4.20801 24.7719 4.20801 23.4053V21.8495C4.20801 21.3607 4.42802 20.8979 4.80708 20.5893L22.9741 5.79938ZM11.373 21.0151V40.5132C11.3741 40.8025 11.4895 41.0797 11.6941 41.2843C11.8987 41.4889 12.176 41.6043 12.4654 41.6053L17.8828 41.6053V33.7807L17.8828 33.7789C17.8872 32.2704 18.4884 30.8249 19.5551 29.7583C20.6218 28.6916 22.0672 28.0904 23.5757 28.086L23.5776 28.086L24.4244 28.086C25.9329 28.0904 27.3783 28.6916 28.445 29.7583C29.5117 30.825 30.1129 32.2704 30.1173 33.7789L30.1173 33.7807L30.1173 41.6053H35.5339C35.8233 41.6043 36.1012 41.4889 36.3058 41.2843C36.5104 41.0796 36.6259 40.8024 36.6269 40.513V21.015L24.2358 10.9946C24.0983 10.8834 23.9017 10.8834 23.7642 10.9946L11.373 21.0151ZM28.8673 41.6053V33.7816C28.8636 32.6037 28.3941 31.4751 27.5611 30.6422C26.7282 29.8092 25.5995 29.3397 24.4216 29.336H23.5785C22.4006 29.3396 21.2719 29.8092 20.439 30.6421C19.606 31.4751 19.1365 32.6037 19.1328 33.7817V41.6053H28.8673ZM24.2368 6.76876C24.0989 6.65651 23.9011 6.65651 23.7633 6.76876L5.59625 21.5586C5.50878 21.6299 5.45801 21.7367 5.45801 21.8495V23.4053C5.45801 23.7207 5.8236 23.8952 6.06881 23.6969L22.9782 10.0226C23.5742 9.54068 24.4259 9.54068 25.0218 10.0226L41.9312 23.6969C42.1764 23.8952 42.542 23.7207 42.542 23.4053V21.8495C42.542 21.7367 42.4912 21.6299 42.4038 21.5586L24.2368 6.76876Z"
            fill="#333333"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
